<template>
  <div class="mic-selector" @click.stop>
    <div v-if="micVisible" class="mic-menu-fixed" @click.stop>
      <!-- 设备麦克风 -->
      <div class="mic-menu-item">
        <span class="mic-menu-label">设备麦克风：</span>
        <div
          class="select-wrapper"
          :class="{ empty: !deviceMicrophone }"
          data-placeholder="无匹配数据"
        >
          <select
            v-model="deviceMicrophone"
            @change="handleDeviceMicrophoneChange"
            class="native-select"
          >
            <option
              v-for="item in equipment.microphone"
              :key="item"
              :value="item"
              >{{ item }}</option
            >
          </select>
        </div>
      </div>

      <!-- 喊话麦克风 -->
      <div class="mic-menu-item">
        <span class="mic-menu-label">喊话麦克风：</span>
        <div
          class="select-wrapper"
          :class="{ empty: !callingMicrophone }"
          data-placeholder="无匹配数据"
        >
          <select
            v-model="callingMicrophone"
            @change="handleCallingMicrophoneChange"
            class="native-select"
          >
            <option
              v-for="item in callingMicrophoneOptions"
              :key="item.deviceId"
              :value="item.deviceId"
              >{{ item.label }}</option
            >
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { mapApi } from '@/utils'

export default {
  name: 'MicSelectorFixed',
  model: {
    prop: 'micVisible',
    event: 'input',
  },
  props: {
    micVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      callingMicrophoneOptions: [],
      deviceMicrophone: '',
      callingMicrophone: '',
    }
  },
  computed: {
    ...mapState('devicePatrolDetail', {
      equipment: state => state.equipment || {},
      curPlayDevice: state => state.curPlayDevice || {},
    }),
  },
  async mounted() {
    // 请求权限并列出所有音频输入设备
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true, video: false })
      const devices = await navigator.mediaDevices.enumerateDevices()
      this.callingMicrophoneOptions = devices.filter(
        d => d.kind === 'audioinput'
      )
    } catch (err) {
      console.error('无法获取麦克风权限或设备列表', err)
    }

    // 初始化选中值
    this.callingMicrophone =
      this.callingMicrophoneOptions.length > 0
        ? this.callingMicrophoneOptions[0].deviceId
        : ''
    this.deviceMicrophone =
      this.equipment.microphone && this.equipment.microphone.length > 0
        ? this.equipment.microphone[0]
        : ''

    // 将初始喊话麦克风存入 Vuex
    this.setCurCallingMicrophone(this.callingMicrophone)
  },
  methods: {
    ...mapApi(['getSendOrder', 'getEquipmentById']),
    ...mapMutations('devicePatrolDetail', [
      'setCurDeviceMicrophone',
      'setCurCallingMicrophone',
      'setCurPlayDeviceStreamUrl',
    ]),

    async handleCallingMicrophoneChange() {
      this.setCurCallingMicrophone(this.callingMicrophone)
    },

    async handleDeviceMicrophoneChange() {
      this.setCurDeviceMicrophone(this.deviceMicrophone)

      // 关闭旧流
      await this.getSendOrder({
        eqIds: [this.curPlayDevice.id],
        isIntranet: this.curPlayDevice.intranet,
        orderCode: 'endPush',
      })

      const id = this.equipment.id
      const { version } = await this.getEquipmentById({ id })
      this.setCurPlayDeviceStreamUrl(null)

      // 根据设备类型开启新流
      let resUrl
      if (this.curPlayDevice.type === 0) {
        resUrl = await this.getSendOrder({
          eqIds: [id],
          isIntranet: this.equipment.intranet,
          orderCode: 'startPush',
          localIp: this.equipment.localIp,
          version,
          microphone: this.deviceMicrophone,
        })
      } else {
        resUrl = await this.getSendOrder({
          eqIds: [id],
          isIntranet: this.equipment.intranet,
          orderCode: 'openCamera',
          cameraName: this.curPlayDevice.cameraName,
          localIp: this.equipment.localIp,
          version,
          microphone: this.deviceMicrophone,
        })
      }
      // this.setCurPlayDeviceStreamUrl(resUrl + `?_t=${Date.now()}`)
      this.setCurPlayDeviceStreamUrl(resUrl)
    },
  },
}
</script>

<style lang="less" scoped>
.mic-selector {
  display: inline-block;
}

/* 固定在屏幕右下角 */
.mic-menu-fixed {
  position: absolute;
  bottom: 5%;
  right: 2%;
  padding: 8px;
  background: rgba(77, 77, 78, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  white-space: nowrap;
}

/* 每一行 */
.mic-menu-item {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.mic-menu-label {
  margin-right: 8px;
  font-size: 14px;
  color: #fff;
}

/* select 外壳，用于伪元素定位 */
.select-wrapper {
  position: relative;
  display: inline-block;
}

/* placeholder 伪元素 */
.select-wrapper.empty::before {
  content: attr(data-placeholder);
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: rgb(197, 200, 206);
  font-size: 14px;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.native-select {
  appearance: none;
  width: 160px;
  height: 24px;
  line-height: 24px;
  padding: 0 20px 0 6px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 下拉箭头 */
.select-wrapper::after {
  content: 'V';
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%) scaleX(1.5);
  transform-origin: center;
  font-size: 14px;
  color: #888;
  pointer-events: none;
}

select:focus option:checked {
  background: rgba(227, 244, 252, 1);
}

select:focus option:hover {
  background: rgba(227, 244, 252, 1);
}

.mic-menu-item:last-child {
  margin-bottom: 0;
}
</style>
